import React, { useState } from "react";
import { Loader2 } from "lucide-react";
import { useCatalog } from "./pricingCatalog";
import { SaveBar } from "./pricingDraft";
import CatalogEditor from "./CatalogEditor";
import QuoteSimulator from "./QuoteSimulator";
import CatalogImport from "./CatalogImport";
import PricingLegacy from "./PricingLegacy";
import { PageHeader } from "../../components/PageHeader";

const TABS = [["catalog", "Katalog Harga"], ["quote", "Simulator"], ["import", "Impor dari docs"], ["global", "Global & fallback"]];

export default function PlatformPricing({ readOnly }) {
  const [tab, setTab] = useState("catalog");
  const { data, draft, patch, save, reset, busy, dirty, apply } = useCatalog();
  if (!data || !draft) return <p className="flex items-center gap-2 text-sm text-slate-400"><Loader2 size={14} className="animate-spin" /> Memuat katalog…</p>;
  const g = data.globals;
  return (
    <div data-testid="platform-pricing">
      <PageHeader title="Tarif & Margin" description={`kredit = USD × qty ÷ qty dasar × (1 + margin) × (1 + PPN) ÷ $${g.usd_per_credit}. Margin/PPN: komponen → layanan → provider → global (${g.margin_pct}% / ${g.tax_pct}%). Kosong = ikut induk.`}>
        {(tab === "catalog" || (readOnly && tab === "import")) && <SaveBar dirty={dirty} busy={busy} onSave={save} onReset={reset} readOnly={readOnly} testid="catalog" />}
      </PageHeader>
      <div className="tabs mt-5">
        {TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} data-testid={`pricing-tab-${k}`} className={`tab ${tab === k ? "tab-active" : ""}`}>{l}</button>)}
      </div>
      <div className="mt-5">
        {tab === "catalog" && <CatalogEditor draft={draft} globals={g} units={data.units} patch={patch} readOnly={readOnly} />}
        {tab === "quote" && <QuoteSimulator catalog={data.catalog} featureMap={data.feature_map} />}
        {tab === "import" && <CatalogImport providers={data.catalog.providers} onApplied={apply} readOnly={readOnly} dirty={dirty} />}
        {tab === "global" && <PricingLegacy readOnly={readOnly} />}
      </div>
    </div>
  );
}
